// utils/exportToExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";

export const exportToExcel = async (data) => {
  console.log("data", data);
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet 1");

  // Add header and data
  worksheet.getColumn("A").width = 20;
  worksheet.getColumn("B").width = 20;
  worksheet.getColumn("C").width = 20;
  worksheet.getColumn("D").width = 20;
  worksheet.getColumn("E").width = 20;
  worksheet.getColumn("F").width = 20;
  worksheet.getColumn("G").width = 20;
  worksheet.getColumn("H").width = 20;
  worksheet.mergeCells("B2:D2");
  worksheet.getCell("B2").value = "Agence";
  worksheet.getCell("B2").alignment = { horizontal: "center" };
  worksheet.getCell("B2").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFFFFF00" }, // yellow
  };
  worksheet.addRow([
    "Date de vol",
    "Nom",
    "PassportNumber",
    "Télphone",
    "Agence",
    "Guide",
    "Premiere fois",
  ]);
  data.sort((a, b) => {
    if (a.disponibility && b.disponibility) {
      return new Date(a.disponibility.date) - new Date(b.disponibility.date);
    }
  });
  data.forEach((element) => {
    (element.surrveyState != 7 || element.surrveyState != 3) &&
      worksheet.addRow([
        element.disponibility &&
        element.disponibility.date &&
        moment(element.disponibility.date).format("DD/MM/YYYY") != "01/01/0001"
          ? moment(element.disponibility.date).format("DD/MM/YYYY")
          : "B2B",
        element.customer.name ? element.customer.name : "",
        element.customer.passportNumber ? element.customer.passportNumber : "",
        element.customer.phoneNumber ? element.customer.phoneNumber : "",
        element.client.name ? element.client.name : "",
        element.guideName ? element.guideName : "",
        element.customer.survey
          ? element.customer.survey.isFirstTime == 0
            ? "NON"
            : "OUI"
          : "Pas de survey",
      ]);
  });

  //   Style headers
  ["B2"].forEach((cell) => {
    const headerCell = worksheet.getCell(cell);
    headerCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFCCE5FF" }, // light blue
    };
    headerCell.font = {
      size: 17,
      bold: true,
      color: { argb: "#3498db" }, // red
    };
  });
  ["A3", "B3", "C3", "D3", "E3", "F3", "G3"].forEach((cell) => {
    const headerCell = worksheet.getCell(cell);
    // headerCell.fill = {
    //   type: "pattern",
    //   pattern: "solid",
    //   fgColor: { argb: "" }, // light blue
    // };
    headerCell.font = {
      size: 12,
      bold: true,
      color: { argb: "#3498db" }, // red
    };
    headerCell.border = {
      top: { style: "thick", color: { argb: "FF000000" } },
      left: { style: "thick", color: { argb: "FF000000" } },
      bottom: { style: "thick", color: { argb: "FF000000" } },
      right: { style: "thick", color: { argb: "FF000000" } },
    };
  });

  // Export as Excel
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "StyledExport.xlsx");
};
